import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { gameState } from "appworks/model/game-state";
import { UIFlagState } from "appworks/ui/flags/ui-flag-state";
import { uiFlags, UIFlag } from "appworks/ui/flags/ui-flags";
import { UIHook } from "appworks/ui/flags/ui-hooks";
import { GamingRealms } from "gaming-realms/gaming-realms";
import { SlingoInitState } from "slingo/states/slingo-init-state";

export class FowlInitState extends SlingoInitState {
    public onExit(): void {
        super.onExit();

        if (!gameState.getCurrentGame().isRecovered) {
            const prompt = new PromptContentSubcomponent(["scatterinfo"], 5000);
            prompt.setClickToSkip(true);
            Components.get(PromptComponent)
                .showPrompt(prompt)
                .execute();
        }

        // Copied idle hook hacks from Lucky Joker, as it's another slot bonus so has the same issue
        // The standard idlehook triggers when the slot bonus goes idle so I need it to also take the FREE_SPINS flag into account
        // https://gamingrealms.atlassian.net/browse/STUDIOEPIC-691
        const hooks: UIHook[] = (uiFlags as any).hooks;
        const idleHook = hooks.find(hook => hook.flagState.mustMatch === 1 && hook.flagState.mustNotMatch === 0);
        idleHook.on.removeAll();
        idleHook.off.removeAll();
        const newIdleHook = uiFlags.hook(new UIFlagState(UIFlag.IDLE, UIFlag.FREE_SPINS));
        newIdleHook.on.add(() => GamingRealms.setWrapperGameState(so.GameState.GAME_IDLE));
        newIdleHook.off.add(() => GamingRealms.setWrapperGameState(so.GameState.GAME_BUSY));
    }
}
